<template>
  <div>
    <el-form :model="formCopy" label-width="100px">
      <component
        :is="widgetComponent"
        :form.sync="formCopy"
        :errors="errors"
        ref="widgetForm"
      />
      <div class="buttons">
        <el-button @click="$emit('cancel')">Anuluj</el-button>
        <el-button type="primary" @click="submitForm">Zatwierdź</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { Widget } from '@/api'
import { cloneDeep } from 'lodash'

export default {
  data() {
    return {
      formCopy: {},
      errors: {},
      originalForm: {}
    }
  },
  props: {
    widget: { type: Object, required: true },
    errorsFromForm: { type: Object, default: () => ({}) }
  },
  mounted() {
    this.errors = cloneDeep(this.errorsFromForm)
    this.formCopy = cloneDeep(this.widget)
  },
  computed: {
    widgetComponent() {
      return this.getWidgetComponent(this.formCopy.resourcetype)
    }
  },
  methods: {
    async submitForm() {
      const payload = await this.$refs.widgetForm.getPayload()

      Widget.validate(payload)
        .then(response => {
          this.$emit('submit', payload)
        })
        .catch(this.errorHandler)
    }
  }
}
</script>
<style lang="scss" scoped>
.buttons {
  margin-top: 25px;
  text-align: right;
}
</style>
